// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__RHnRs","list":"Contact_list__jHUpD","socialsList":"Contact_socialsList__lpwnc","or":"Contact_or__3g6uB","emailUs":"Contact_emailUs__AULBt"};